export const GenderList = [
  { title: 'Male', value: 'male' },
  { title: 'Female', value: 'female' },
  { title: 'Anon/Other', value: 'other' },
]

export const LanguageList = [
  {
    title: '简体中文',
    value: 'zh',
    isBeta: false,
  },
  {
    title: 'English',
    value: 'en',
    isBeta: false,
  },
  {
    title: 'Tiếng Việt',
    value: 'vi',
    isBeta: false,
  },
  {
    title: 'Français',
    value: 'fr',
    isBeta: false,
  },
  // {
  //   title: "Bahasa Indonesia",
  //   value: "id",
  //   isBeta: true,
  // },
  // {
  //   title: "Deutsch",
  //   value: "de",
  //   isBeta: true,
  // },
  // {
  //   title: "Español",
  //   value: "es",
  //   isBeta: "true",
  // },
  // {
  //   title: "Magyarország",
  //   value: "hu",
  //   isBeta: true,
  // },
  // {
  //   title: "русский язык",
  //   value: "ru",
  //   isBeta: true,
  // },

  {
    title: "ภาษาไทย",
    value: "th",
    isBeta: false,
  },
  {
    title: "한국어",
    value: "ko",
    isBeta: false,
  },
  {
    title: 'Монгол',
    value: 'mn',
    isBeta: false,
  },
  {
    title: '日本語',
    value: 'ja',
    isBeta: false,
  },
  {
    title: 'Русский язык',
    value: 'ru',
    isBeta: false,
  },
  {
    title: 'العربية',
    value: 'ar',
    isBeta: false,
  },
  {
    title: 'Български',
    value: 'bg',
    isBeta: false,
  },
]

export const GradeAbilities = ['listen', 'speak', 'read', 'write', 'translate']
